import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import Router from "vue-router";
import Vuex from "vuex";
import CxltToastr from "cxlt-vue2-toastr";

import router from "./router";
import store from "./store";
import { money, number, date, time, protect } from "./useful/filters";

// import { Integrations } from "@sentry/tracing";

// import * as Sentry from "@sentry/vue";

import VueTheMask from 'vue-the-mask';

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

// datepicker
// https://github.com/mengxiong10/vue2-datepicker#readme
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import * as VeeValidate from 'vee-validate';

import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from 'vee-validate/dist/vee-validate.full';

import Portuguese from 'vee-validate/dist/locale/pt_BR.json'

// fake loader components global
import ContentLoading from "@/components/skeletonLoading/contentLoading";
import FakeLine from "@/components/skeletonLoading/fakeLine";
import FakeSquare from "@/components/skeletonLoading/fakeSquare";
import FakeChart from "@/components/skeletonLoading/fakeChart";

Vue.component('ContentLoading', ContentLoading);
Vue.component('FakeLine', FakeLine);
Vue.component('FakeChart', FakeChart);
Vue.component('FakeSquare', FakeSquare);

// components validator
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import AnimatedNumber from "animated-number-vue"
Vue.component('AnimatedNumber', AnimatedNumber);


localize('pt_BR', Portuguese)

// fix to Chart.js 3.0
import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);


Vue.use(VeeValidate, {
  locale: 'pt_BR',
  inject: true,
  fieldsBagName: '$veeFields',
  errorBagName: '$veeErrors',
})


import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

Vue.use(VueTheMask)

Vue.use(Datetime);
Vue.use(DatePicker);

Vue.use(Vuex);
Vue.use(Router);

Vue.filter("money", money);
Vue.filter("number", number);
Vue.filter("date", date);
Vue.filter("time", time);
Vue.filter("protect", protect);

var toastrConfigs = {
  position: "bottom",
  showDuration: 9,
  progressBar: true,
  timeOut: 3000
};

Vue.use(CxltToastr, toastrConfigs);

// logout all user exist param customer_new=1
router.beforeEach((to, from, next) => {
  if (store.state.user && store.state.user.token && to.query && to.query.customer_new) {
    store.dispatch("logout")
    return next("/?customer_new=1");
  }
  next();
})

router.beforeEach((to, from, next) => {
  if (store.state.user 
    && store.state.user.token 
    && (to.path.includes("/register") || to.path.includes("/login")) ) {
    store.dispatch("logout")
    //return next("/?customer_new=1");
  }
  next();
})


// redirect user auth
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresLogin)) {
    if (!store.state.user.token) {
      next("/");
    }
    next();
  } else {
    if (store.state.user.token) {
      if (
        !to.path.includes("/home")
        && !to.path.includes("/conta-cancelada")
        && !to.path.includes("/onboarding")
        && !to.path.includes("/onboarding-flow")
        && !to.path.includes("/verified-tag")
        && !to.path.includes("/invite-user")
        && !to.path.includes("/invite-new-user")
        && !to.path.includes("/change-password")
        && !to.path.includes("/oauth2")) {
        next("/home");
      }
    }
    next();
  }
});

// check account status
router.beforeEach((to, from, next) => {
  let accountStatus = store.state.account.status;
  let planName = store.state.account.plan;

  if (!to.path.includes("/onboarding") && !to.path.includes("/onboarding-flow")) {
    if (accountStatus === 'ONBOARDING' && planName !== 'SELECTPLAN') {
      return next("/onboarding")
    }

    if (planName === 'SELECTPLAN') {
      return next("/onboarding-flow")
    }
  }

  if (!to.path.includes("/conta-cancelada")) {
    if (accountStatus === 'CANCELED') {
      return next("/conta-cancelada")
    }
  }

  return next();
});

function redirect_permission(to, next, resources, planName) {
  if (
    to.matched.some(record => record.meta.requiresLogin) &&
    to.matched.some(record => record.meta.permissionName)
  ) {
    if (resources && !resources.includes(to.meta.permissionName)) {
      if (planName && planName.toLowerCase() === 'freemium') {
        return next("/versao-pro")
      } else {
        return next("/home");
      }
    }
  }
  next();
}


// check permission from route
router.beforeEach((to, from, next) => {
  let planName = store.state.account.plan;
  let resources = store.state.account.resources;

  redirect_permission(to, next, resources, planName);
});

// cancel request in change route axios
router.beforeEach((to, from, next) => {
  // Change location.href to add #
  if (to.name !== from.name) {
    store.dispatch('CANCEL_PENDING_REQUESTS');
  }

  next();
})

// save hash params
router.beforeEach((to, from, next) => {
  // Change location.href to add #
  if (from.hash && !to.hash && to.name != 'Login') {
    const path = `${to.path}${from.hash}`
    next(path)
    return
  }

  next();
})

// remove hash in demo account
router.beforeEach((to, from, next) => {
  // Change location.href to add #
  let demoAccId = process && process.env && process.env.VUE_APP_DEMO_ACCOUNT
  if (to.name === 'Login' && to.hash.includes(`#acc=${demoAccId}`)) {
    next({
      path: '/',
      params: {},
      replace: true,
      hash: '',
    })
    return
  }

  next();
})


// css
import "@/scss/toastr.scss";

require("./scss/main.scss");

Vue.prototype.$ObjectCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

Vue.prototype.$filters = Vue.options.filters;



new Vue({
  render: h => h(App),
  store,
  router,
  locale: 'pt_BR'
}).$mount("#app");
